// #53 EmptyState: a 48 px icon tile, his sentence (or a Q-E15 line), an optional second line and one link to the
// screen that fills it. `inline`: inside a populated page, one --text-3 line instead of the tile. `revoked`: the
// lock-icon form for withdrawn access (V-10).

import type { ReactNode } from "react";
import { cx } from "../lib/cx";
import { Icon, type IconName } from "./icons";

export interface EmptyStateProps {
  /** The sentence. */
  children: ReactNode;
  icon?: IconName | undefined;
  sub?: ReactNode | undefined;
  /** One link (a TextLink). */
  action?: ReactNode | undefined;
  inline?: boolean | undefined;
  revoked?: boolean | undefined;
  className?: string | undefined;
}

export function EmptyState({ children, icon, sub, action, inline, revoked, className }: EmptyStateProps) {
  if (inline) return <p className={cx("mc-empty-line", className)}>{children}</p>;
  return (
    <div className={cx("mc-empty", revoked && "mc-empty-revoked", className)}>
      <span className="mc-empty-i"><Icon name={revoked ? "lock" : (icon ?? "inbox")} /></span>
      <p className="mc-empty-t">{children}</p>
      {sub ? <p className="mc-empty-s">{sub}</p> : null}
      {action ?? null}
    </div>
  );
}
